import Vue from 'vue';
import apiFactory from '@/api/default';
const API = apiFactory('grippers');

const state = {
  gripperSearchResults: [],
  currentGripper: {},
};

const getters = {
  gripperSearchResults: (state) => state.gripperSearchResults,
  currentGripper: (state) => state.currentGripper,
};

const mutations = {
  setGripperSearchResults: (state, gripperSearchResults) => {
    state.gripperSearchResults = gripperSearchResults;
  },
  removeFromGripperSearchResults: (state, id)=>{
    state.gripperSearchResults.data = state.gripperSearchResults.filter((obj)=>{
      return obj._id !== id;
    });
    state.gripperSearchResults.total--;
  },
  setCurrentGripper: (state, currentGripper) => {
    state.currentGripper = currentGripper;
  },
  updateCurrentGripperProperties: (state, properties) => {
    for (const key in properties) {
      if (Object.prototype.hasOwnProperty.call(properties, key)) {
        Vue.set(state.currentGripper, key, properties[key]);
      }
    }
  },
};

const actions = {
  async searchGrippers({commit}, data) {
    const response = await API.search(data.query);
    commit('setGripperSearchResults', response.data);
    return response.data;
  },
  async loadGripper({commit}, data) {
    const response = await API.load(data.id, data.query);
    commit('setCurrentGripper', response.data);
    return response.data;
  },
  async createGripper({commit}, data) {
    const response = await API.create(data);
    return response.data;
  },
  async updateGripper({commit}, payload) {
    const response = await API.update(payload.id, payload.props);
    // If the update is successful update currentGripper with the supplied props
    commit('updateCurrentGripperProperties', payload.props);
    return response.data;
  },
  async deleteGripper({commit}, id) {
    const response = await API.remove(id);
    commit('removeFromGripperSearchResults', id);
    return response;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
